<div *ngIf="bookingByClub?.length" class="wrap">

  <div class="table" *ngIf="tab === 'closedBooking'">

    <table mat-table aria-label="tableau vitrine du club" [dataSource]="dataSource" matSort multiTemplateDataRows>
      <ng-container matColumnDef="offerNameOfferInProgress">
        <th mat-header-cell *matHeaderCellDef class="cell_text" mat-sort-header="offerNameOfferInProgress">
          <app-pop-up-filter idFilter="popup_filter_offer_inprogress_offername" column="bookingReference"
            [offers]="getDataToCheckBox('bookingReference')">
          </app-pop-up-filter>
          Nom de l'offre
        </th>
        <td mat-cell *matCellDef="let element" class="cell_text"> {{element.bookingReference}} </td>
      </ng-container>

      <ng-container matColumnDef="bookedOfferRecordDate">
        <th mat-header-cell *matHeaderCellDef class="cell_text" mat-sort-header="bookedOfferRecordDate"> Date d'achat
        </th>
        <td mat-cell *matCellDef="let element" class="cell_text"> {{element.bookingRecordDate | date}} </td>
      </ng-container>

      <ng-container matColumnDef="bookedOfferStatus">
        <th mat-header-cell *matHeaderCellDef class="cell_text" [style.text-align]="'center'">
          <!-- <app-pop-up-filter idFilter="popup_filter_offer_inprogress_bookingGlobalStatus" column="bookingGlobalStatus"
            [offers]="getDataToCheckBox('bookingGlobalStatus')" [status]="getStatusOffer()">
          </app-pop-up-filter> -->
          Statut du panier
        </th>
        <td mat-cell *matCellDef="let element" class="cell_text" [style.text-align]="'center'">
          <!-- {{returnStatus(element.bookingStatusKey)?.bookedOfferStatus || '-'}} -->
          {{element.bookingGlobalStatus}}
        </td>
      </ng-container>

      <ng-container matColumnDef="bookingamount">
        <th mat-header-cell *matHeaderCellDef class="cell_text" mat-sort-header="bookingAmount">
          <app-pop-up-filter idFilter="popup_filter_offer_inprogress_bookingAmount" column="bookingamount"
            [offers]="getDataToCheckBox('bookingamount')">
          </app-pop-up-filter>
          Prix
        </th>
        <td mat-cell *matCellDef="let element" class="cell_text">
          {{element.bookingAmount}}€
        </td>
      </ng-container>

      <ng-container matColumnDef="leftToPay">
        <th mat-header-cell *matHeaderCellDef class="cell_text" [style.text-align]="'center'"> Reste à payer
        </th>
        <td mat-cell *matCellDef="let element" class="cell_text" [style.text-align]="'center'"
          [ngClass]="{green: (element.bookingAmount - (element.bookingPayedAmount || 0) ) === 0, red:  (element.bookingAmount - (element.bookingPayedAmount || 0) )> 0 }">
          {{ element.bookingAmount - (element.bookingPayedAmount || 0) }}€ </td>
      </ng-container>

      <ng-container matColumnDef="overview">
        <th mat-header-cell *matHeaderCellDef class="cell_text" [style.text-align]="'center'"> Aperçu </th>
        <td mat-cell *matCellDef="let element" class="cell_text" [style.text-align]="'center'">
          <fa-icon [icon]="getFaIcon('faImage')" appChangeColorTheme attribute="color" (click)="changePreview(element)" matTooltip="Afficher l'aperçu de cette offre">
          </fa-icon>
          <!-- <fa-icon class="faIconComment" *ngIf="element.memoMessageUser" [icon]="getFaIcon('faComment')" (click)="openDialogComment(element)" matTooltip="Voir le commentaire"> -->
            <span class="faIconComment" *ngIf="element.memoMessageUser" (click)="openDialogComment(element)" matTooltip="Voir le commentaire">C</span>
          <!-- </fa-icon> -->
        </td>
      </ng-container>

      <ng-container matColumnDef="pdf">
        <th mat-header-cell *matHeaderCellDef class="cell_text" [style.text-align]="'center'"> Facture </th>
        <td mat-cell *matCellDef="let element" class="cell_text" [style.text-align]="'center'">
          <fa-icon [icon]="getFaIcon('faFilePdf')" [matTooltip]="'Télécharger la facture'" appChangeColorTheme
            attribute="color" (click)="exportPdfBill(element)"></fa-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="closePopUp()">
      </tr>
    </table>
    <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" [color]="color">
    </mat-paginator>
  </div>

  <app-table-booking-progress *ngIf="tab === 'basket'" [sesisonBookSelected]="sesisonBookSelected">
  </app-table-booking-progress>


  <div class="bookOverview">

    <div class="infos_book">
      <div class="status_book_number_bill">
        <span> Panier: <strong>{{bookOverview?.bookingReference}}</strong></span>

      </div>
      <div class="infos_user">
        <div [style.margin-bottom.px]="10" [style.width.%]="100">
          <fa-icon [style.margin-right.px]="5" [icon]="getFaIcon('faUser')" appChangeColorTheme attribute="color">
          </fa-icon>
          {{bookOverview?.firstName}} {{bookOverview?.lastName}}
        </div>
        <div [style.width.%]="100">
          <a [href]="'mailto:' + bookOverview?.email" (click)="$event.stopPropagation()">
            <fa-icon [style.margin-right.px]="5" [icon]="getFaIcon('faEnvelope')" appChangeColorTheme attribute="color">
            </fa-icon>
            {{bookOverview?.email}}
          </a>
        </div>
        <div [style.width.%]="100" [style.margin-top.px]="10">
          <fa-icon [style.margin-right.px]="5" [icon]="getFaIcon('faMobileAlt')" appChangeColorTheme attribute="color">
          </fa-icon>
          <!-- {{bookOverview?.phoneNumberUser || 'N° non communiqué'}} -->
        </div>
      </div>
    </div>
    <ul>
      <li *ngFor="let o of sesisonBookSelected">
        <span><strong>{{o.bookedSessionQuantity}}</strong>x</span>
        <span>{{o?.offer.offerName}} </span>
        <span><strong>{{o.bookedSessionAmount || 0}}€</strong></span> </li>
    </ul>

    <div class="price">
      <span>Reste à payer</span>
      <span
        [ngClass]="{green: (bookOverview?.bookingAmount - (bookOverview?.bookingPayedAmount || 0) ) === 0, red:  (bookOverview?.bookingAmount - (bookOverview?.bookingPayedAmount || 0) )> 0 }"><strong>{{ bookOverview?.bookingAmount - (bookOverview?.bookingPayedAmount ||0) }}€</strong></span>
    </div>

    <div class="price">
      <span>Total du panier</span>
      <span><strong>{{bookOverview?.bookingAmount}}€</strong></span>
    </div>
  </div>
</div>

<p *ngIf="!bookingByClub?.length" class="no_offers">Il n'y a pas de réservation clôturée pour votre club.</p>
